import { useState } from 'react';
import { Typography } from '@mui/material';
import round from '@/util/round';
import DocumentViewDialog from '@/components/shared/DocumentViewDialog';
import type { Doc } from '@/types/sharedTypes';

interface SourceDocumentProps {
  doc: Doc & {
    certainty: number;
    start_line?: number;
    end_line?: number;
  };
}

function SourceDocument({ doc }: SourceDocumentProps): React.JSX.Element {
  const [open, setOpen] = useState<boolean>(false);

  const doc_page =
    doc.start_line && doc.end_line
      ? `${doc.start_line} - ${doc.end_line}`
      : undefined;

  return (
    <>
      <Typography
        component='span'
        onClick={() => {
          setOpen(true);
        }}
        variant='caption'
        sx={{ padding: '1px', cursor: 'pointer', textDecoration: 'underline' }}
      >
        {round(doc.certainty * 100, 2)}% - {doc.title}{' '}
        {doc_page ? `- lines ${doc_page}` : ''}
      </Typography>
      <DocumentViewDialog
        title={`${doc.title} ${doc_page ? `- lines ${doc_page}` : ''}`}
        contents={doc.content}
        open={open}
        handleClose={() => setOpen(false)}
      />
    </>
  );
}

export default SourceDocument;

